module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-pulse-mobile.en-755c7d8ea18bbda386667955e695290b.png";